import moment from 'moment-timezone';
import localeEs from 'moment/locale/es';
import localeAu from 'moment/locale/en-au';
import localeNz from 'moment/locale/en-nz';

export const displayDate = (date, timezone, format = 'L LT', lang = 'en-US') => {
  lang = lang.toLowerCase();

  if (lang === 'en-au') {
    return moment(date).locale('en-au', localeAu).tz(timezone).format(format);
  }

  if (lang === 'en-nz') {
    return moment(date).locale('en-au', localeNz).tz(timezone).format(format);
  }

  if (lang === 'es-mx') {
    return moment(date).locale(lang, localeEs).tz(timezone).format(format);
  }

  return moment(date).locale('en').tz(timezone).format(format);
};

export const getDate = (date, format = 'L LT') => {
  return moment(date).format(format);
};

export const getLocaleName = (lang = 'en-US') => lang ? lang.toLowerCase() : 'en';

export const calculateOffset = (date, timezone) => {
  const offset = moment.tz(timezone).utcOffset();
  return moment(date).subtract(offset, 'minutes');
};

export const formatTimestamp = (timestamp, t) => {
  const date = new Date(timestamp);
  const now = Date.now();
  const diff = now - timestamp;
  const minutes = Math.floor(diff / 60000);

  if (minutes < 1) {
    return t('Just now');
  } else if (minutes < 60) {
    return t('{{minutes}} minutes ago', { minutes });
  } else {
    return date.toLocaleString();
  }
};
